<template>
  <div id="app">
    <nav-bar v-if="isLoggedIn"></nav-bar>
    <div class="container-fluid pt-3">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import NavBar from "@app/components/navigation/NavBar";

export default {
  components: {
    NavBar
  },

  computed: {
    ...mapGetters(["isLoggedIn"])
  }
};
</script>
